/* GSF Schemas : dessine les figures autonomes (.gsf-sch-auto) quand elles entrent dans l'ecran.
   Les panneaux de GSF Angles en onglets gerent leur propre dessin. */
(function () {
  function init(scope) {
    var figs = (scope || document).querySelectorAll('.gsf-sch-auto:not(.sch-ready)');
    if (!figs.length) return;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    figs.forEach(function (fig) {
      if (calm || !('IntersectionObserver' in window)) return; // au repos, tout est visible
      fig.classList.add('sch-ready');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        requestAnimationFrame(function () { fig.classList.add('is-drawn'); });
      }, { threshold: 0.3 });
      io.observe(fig);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
